export default __webpack_public_path__ + "static/lavapavimenti_-66b317ef2c6f22d72cc0efcb7b0b8287.jpg";